 
<div #splashScreen id="splash-screen">
  <div class="flex items-center flex-col">
    <div id="wifi-loader">
      <img
        alt="Logo"
        [src]="
          (agentLogo() | addApiUrlBeforePath) || '/assets/media/logos/logo.png'
        "
        class="w-[164px]"
      />
    </div>
  </div>
  <div #splashScreen [id]="'splash-screen-overlay'"></div>
</div>
